import http from "../../BaseConfigurationApiHttp";

class FactoryService {
  getFactoriesForUser() {
    return http.get(`/user/factories`);
  }
  getFactoryWorkShifts(factoryId) {
    return http.get(`factories/${factoryId}/assigned-work-shift-names`);
  }
  getFactoryProducts(factoryId) {
    return http.get(`factories/${factoryId}/products`);
  }
  getAvailableCurrencyCodes() {
    return http.get(`/currency-list`);
  }
}

export default new FactoryService();
